import {request} from '@/helpers/apiClient';
import {RACK_CATALOG_CONFIG} from '@/utils/constants/apiConfig/rackCatalogConfig';

export const createRack = (options) =>
  request(RACK_CATALOG_CONFIG.CREATE_RACK, options);

export const updateRack = (id, options) =>
  request(RACK_CATALOG_CONFIG.UPDATE_RACK(id), options);

export const deleteRack = (id) => request(RACK_CATALOG_CONFIG.DELETE_RACK(id));
